import { openBooking } from "@/lib/analytics";

const BASE =
  "inline-flex items-center justify-center gap-3 rounded-full font-semibold uppercase tracking-[0.12em] transition-[transform,box-shadow,background-color,background-position,color] duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E6CA65] focus-visible:ring-offset-2 focus-visible:ring-offset-[#080705] active:scale-[0.98]";

const SIZES = {
  lg: "min-h-[56px] px-10 text-base sm:text-lg",
  md: "min-h-[48px] px-7 text-sm sm:text-base",
  sm: "min-h-[44px] px-6 text-xs sm:text-sm",
};

const VARIANTS = {
  solid: "btn-gold text-[#0A0805]",
  outline:
    "border border-[#D4AF37]/50 bg-[#D4AF37]/[0.06] text-[#F3E5AB] backdrop-blur-sm hover:bg-[#D4AF37]/[0.14]",
};

// Every "Book Tickets" button on the site routes through here ->
// central BookMyShow URL + conversion tracking, always in sync.
export function BookButton({
  location,
  label = "Book Tickets",
  variant = "solid",
  size = "lg",
  className = "",
  testId,
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={`${label} — opens the official BookMyShow listing`}
      onClick={() => openBooking(location)}
      className={`${BASE} ${SIZES[size]} ${VARIANTS[variant]} ${className}`}
    >
      {label}
    </button>
  );
}
